import { API } from 'utils';
import { RootDispatch } from '../store';
import {
  CountryCodesData,
  CountyCodesData,
  PhonePrefixesData,
  AddressTypeData
} from './referenceData.model';

const effects = (dispatch: RootDispatch) => ({
  async getPhonePrefixes(): Promise<PhonePrefixesData | undefined> {
    const url = '/reference/country/prefixes';
    return API.get<void, PhonePrefixesData>(url)
      .then((response) => {
        dispatch.referenceData.storePhonePrefixes(response.data.prefixes);
        return response;
      })
      .catch(() => undefined);
  },
  async getCountryCodes(): Promise<CountryCodesData | undefined> {
    const url = '/reference/country/codes';
    return API.get<void, CountryCodesData>(url)
      .then((response) => {
        dispatch.referenceData.storeCountryCodes(response.data.countryCodes);
        return response;
      })
      .catch(() => undefined);
  },
  async getCountyCodes(): Promise<CountyCodesData> {
    const url = '/reference/address/counties';
    return API.get<void, CountyCodesData>(url)
      .then((response) => {
        dispatch.referenceData.storeCountyCodes(response.data.counties);
        return response;
      })
      .catch((err) => {
        console.error(err);
        return err;
      });
  },
  async getAddressType(): Promise<AddressTypeData> {
    const url = '/reference/address/types';
    return API.get<void, AddressTypeData>(url)
      .then((response) => {
        dispatch.referenceData.storeAddressType(response.data.addressTypes);
        return response;
      })
      .catch((err) => {
        console.error(err);
        return err;
      });
  }
});

export default effects;
